import React from "react";
import './staff/staff-modules.css';
import { Link } from "react-router-dom";

const MODULES = [
  {
    title: "Profile",
    description: "View your staff details and photo.",
    icon: "👤",
    link: "/staff/profile"
  },
  {
    title: "Attendance",
    description: "Mark and review student attendance for each batch and subject.",
    icon: "🗓️",
    link: "/staff/attendance"
  },
  {
    title: "Lesson Plan",
    description: "Upload and organize lesson plans, track syllabus coverage.",
    icon: "📚",
    link: "/staff/lessonplan"
  },
  {
    title: "Assessment",
    description: "Enter and review internal assessment marks and analytics.",
    icon: "📝",
    link: "/staff/assessment"
  },
  {
    title: "Clinical Posting",
    description: "Schedule, assign, and monitor clinical postings for students.",
    icon: "🏥",
    link: "/staff/clinical"
  },
  {
    title: "Rotation Plan",
    description: "Manage and schedule rotation plans for students and staff.",
    icon: "🔄",
    link: "/staff/rotation"
  },
  {
    title: "Notices",
    description: "View and publish important college notices and circulars.",
    icon: "📢",
    link: "/staff/notices"
  },
  {
    title: "Library",
    description: "Browse and share reference books and teaching resources.",
    icon: "📖",
    link: "/staff/library"
  },
  {
    title: "Reports",
    description: "Generate, view, and download academic reports.",
    icon: "📊",
    link: "/staff/reports"
  },
  {
    title: "Settings",
    description: "Manage your profile details and password.",
    icon: "⚙️",
    link: "/staff/settings"
  }
];

export default function StaffDashboard() {
  return (
    <div className="dashboard-wrapper">
      <h2>Staff Dashboard</h2>
      <p>Welcome to the GNM College Staff Panel. Select a module to manage academic or administrative activities.</p>
      <div className="dashboard-grid">
        {MODULES.map((mod) => (
          <Link to={mod.link} className="dashboard-card" key={mod.title} aria-label={mod.title}>
            <div className="dashboard-card-icon">{mod.icon}</div>
            <div className="dashboard-card-title">{mod.title}</div>
            <div className="dashboard-card-desc">{mod.description}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}